import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity } from "react-native"
import { useSafeAreaInsets } from 'react-native-safe-area-context';


import tw from '../styles/tailwind';
import Text from '../components/Text';
import Icon from '../components/IcomoonIcon';
import { useNavigation } from '@react-navigation/native';

// backButtonStyle: por defecto la flecha se centra en todo el alto del header; en headers
// altos (ej. con montos y buscador) se puede acotar para alinearla con el título.
export default function Header({ children, title, showBackButton = false, backButtonColor = 'secondary', style={}, backButtonStyle={} }) {
  const insets = useSafeAreaInsets();

  const navigation = useNavigation()

  return (
    <View style={tw.style(`bg-gray-200 pt-[${insets.top}px] px-6 pb-4 rounded-b-2xl mb-3`, style)}>
      <View style={tw.style(`row justify-between mt-5`, { minHeight: 36 }, showBackButton && `pl-9`)}>
        {children}

        {
          !children && !!title &&
            <Text style={tw`text-secondary font-600 text-lg`}>{title}</Text>
        }

        {
          showBackButton &&
            <TouchableOpacity style={tw.style(`absolute -left-3 top-0 bottom-0 px-2 justify-center`, backButtonStyle)} onPress={() => navigation.goBack()}>
              <Icon name='chevron-left' size={18} color={tw.color(backButtonColor)} />
            </TouchableOpacity>
        }
      </View>
    </View>
  )
}

